import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Form, Label, Input,
    Container,
    FormGroup,
    Row,
    Col,
    Alert
} from "reactstrap";
import RoleServices from "../../services/RoleServices";
import UserServices from "../../services/UserServices";



const EditRoleAndPassword = () => {
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [editModal, setEditModal] = useState(false);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [editUser, setEditUser] = useState({
        id: null,
        first_name: '',
        username: '',
        last_name: '',
        email: "",
        role_id: "",
        phone: "",
        password: ""
    });
    const navigate = useNavigate();

    useEffect(() => {
        UserServices.getUsers().then(data => {
            setUsers(data['data']);
        });

        RoleServices.getRoles().then(data => {
            setRoles(data['data']);
        });
    }, []);

    const showRoleTitle = (roleId) => {
        const role = roles.filter((r) => r.id === roleId);
        let element;
        if (typeof role[0] !== 'undefined') {
            element = role[0];
        } else {
            element = {
                title: " "
            }
        }
        return element.title;
    };

    const toggleEditModal = () => {
        setEditModal(!editModal);
    };

    const handleEditUserChange = (event) => {
        setEditUser({ ...editUser, [event.target.name]: event.target.value });
    };

    const handleEditUser = () => {
        const updatedUser = users.map((r) => {
            if (r.id === editUser.id) {
                return editUser;
            } else {
                return r;
            }
        });
        console.log(editUser);
        UserServices
            .updateUserRole(editUser)
            .then(data => {
                console.log(data);
                if (data['success'] === true) {
                    setUsers(updatedUser);
                    setEditUser({
                        id: null,
                        first_name: '',
                        username: '',
                        last_name: '',
                        email: "",
                        role_id: "",
                        phone: "",
                        password: ""
                    });
                    toggleEditModal();
                    setAlert("");
                    setMessage("Le rôle de l'utilisateur a été modifié avec succès !");
                    window.location.reload();
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    return (
        <Container>
            <h1 className='mb-5'>Liste des utilisateurs</h1>
            {message && <Alert color="success">{message}</Alert>}
            {alert && <Alert color="danger">{alert}</Alert>}
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Prénom</th>
                        <th>Nom</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Rôle</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.first_name}</td>
                            <td>{user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            <td>{showRoleTitle(user.role_id)}</td>
                            <td>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setEditUser(user);
                                        toggleEditModal();
                                    }}
                                >
                                    Modifier Rôle
                                </Button>

                                {/* <Button
                                    color="secondary"
                                    onClick={() => {
                                        setEditUser(user);
                                        toggleEditModal();
                                    }}
                                >
                                    Modifier le mot de passe
                                </Button> */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal isOpen={editModal} toggle={toggleEditModal}>
                <ModalHeader toggle={toggleEditModal}>Modifier le rôle : {editUser.first_name} {editUser.last_name}</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="role_id">Rôle</Label>
                                    <Input
                                        type="select"
                                        name="role_id"
                                        id="role_id"
                                        value={editUser.role_id || ''} onChange={handleEditUserChange}
                                    >
                                        <option value="">Sélectionnez un rôle</option>
                                        {roles.map(role => (
                                            <option key={role.id} value={role.id}>{role.title}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleEditUser}>
                        Modifier
                    </Button>{" "}
                    <Button color="secondary" onClick={toggleEditModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default EditRoleAndPassword;
